/**
 * @generated SignedSource<<8c000c535433588a109d4389c20d1e55>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileCard_query$data = {
  readonly currentUser: {
    readonly isMetricSystem: boolean | null | undefined;
    readonly rowId: any;
  } | null | undefined;
  readonly " $fragmentType": "ProfileCard_query";
};
export type ProfileCard_query$key = {
  readonly " $data"?: ProfileCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileCard_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMetricSystem",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ed850d288b23a0fbf1fd68d247f9d0dc";

export default node;
